<template>
  <div class="itempage" style="background: #fff">
    <el-card style="position: relative; padding-bottom: 10px">
      <el-row>
        <el-col :span="12">
          <div style="font-size: 20px; font-weight: bold; color: #4b92ff">{{ tabInfo.name }}</div>
          <div style="display: flex;align-items:baseline">
            <span style="font-weight: 600;">{{ tabInfo.type }} <span v-show="tabInfo.description">•</span>
            </span>
            <span :title="tabInfo.description" class="tabInfo-des">{{ tabInfo.description }}</span>
          </div>
        </el-col>
        <el-col :span="4" :offset="8" style="font-size: 28px;" :style="{ 'color': currentStatusColorType }"> {{
          tabInfo.lifeCycle }}
        </el-col>
      </el-row>
    </el-card>
    <div>
      <WorkflowButton style="margin: 10px 0 0 20px;" :workflowInfo="workflowInfo" @setPageRefresh="pageRefresh">
        <el-dropdown placement="bottom" style="margin-left: 10px" @visible-change="checkDelPriv">
          <el-button size="small">{{ $t("message.button.actions") }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="printPage"> {{ $t("message.button.print") }}
            </el-dropdown-item>
            <el-dropdown-item @click.native="creatNew = true" :disabled="noChange">{{
              $t("message.button.createCAPA") }}
            </el-dropdown-item>
            <el-dropdown-item @click.native="creatChange = true" :style="{ display: visibleCreate }">{{
              $t("message.button.createChange") }}
            </el-dropdown-item>
            <!-- <el-dropdown-item @click.native="saveAs = true">{{ $t("message.button.saveAs") }}
            </el-dropdown-item> -->
            <el-dropdown-item @click.native="addFavorite">{{ $t("message.button.bookmark") }}
            </el-dropdown-item>
            <el-dropdown-item @click.native="removeFavorite">{{ $t("message.button.cancelBookmark") }}
            </el-dropdown-item>
            <el-dropdown-item :disabled="!deletePriv" @click.native="deleteQuality">{{
              $t("message.button.delete") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </WorkflowButton>
    </div>
    <el-dialog v-if="saveAs" class="searchAddQualityList" :title="$t('message.title.saveAs')" :visible.sync="saveAs"
      :close-on-click-modal="!saveAs">
      <SaveAsForm @close="cancelSaveAs"></SaveAsForm>
    </el-dialog>
    <el-dialog v-if="creatNew" class="searchAddQualityList" :title="$t('message.title.add')" :visible.sync="creatNew"
      :close-on-click-modal="!creatNew">
      <Create :baseClass="baseClass_" :creatBy='createQuality' @addToList="addToChangeList"
        @closeCreateNew="closeCreateNew"></Create>
    </el-dialog>
    <el-dialog v-if="creatChange" class="searchAddChangeList" :title="$t('message.title.add')"
      :visible.sync="creatChange" :close-on-click-modal="!creatChange">
      <Create :baseClass="ChangebaseClass_" @addToList="addToChangeList" @closeCreateNew="closeCreateChange">
      </Create>
    </el-dialog>

    <!-- tab切换 -->
    <div class="content">
      <div class="content-title">
        <div @click="tabClick(item, index)" class="content-item" :class="{ active: index == num }"
          v-for="(item, index) in tabList" :key="index">
          <div style="display: flex;">
            <div>
              {{ item.name }}
            </div>
            <div :style="{ 'visibility': item.isResult ? 'visible' : 'hidden', }"
              style=" margin-left: 3px;font-size: 22px;">*</div>
          </div>
        </div>
      </div>
      <div style="height: 6px;background: #ebebeb;"></div>
      <div class="route-content">
        <router-view id="aa" :relUrl="relUrl" v-if="isRouterAlive" :type="quality" @routeClick="reload"
          @refreshTab="refreshTab" @setPageRefresh="pageRefresh" :currentStatusId="workflowInfo.currentStatusId"
          :changeRevInfo="changeInfo" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Create from "@/components/common/Create.vue";
import SaveAsForm from "../common/saveAsFormForCommon.vue";
import { qualityTabList } from "@/utils/publicstate";
import WorkflowButton from './workflowButton.vue'
import { getTabIndex } from "@/utils/index.js"
export default {
  name: 'quality',
  data() {
    return {
      relUrl: "quality",
      quality: "quality",
      saveAs: false,
      creatNew: false,
      baseClass_: "401",
      noChange: false,
      changeInfo: {},
      isRouterAlive: true,
      createQuality: 'createQuality',
      visibleCreate: '',
      creatChange: false,
      ChangebaseClass_: '104',
      tabList: [],
      tabInfo: {
        name: ''
      },
      currentStatusColorType: '',
      deletePriv: false,
      workflowInfo: {
        workflowId: '',
        currentStatusId: ''
      },
      tabIdLists: [],
      objInfo: {}
    };
  },
  components: {
    Create,
    SaveAsForm,
    WorkflowButton
  },
  mounted() { },
  methods: {
    getBaseClass() {
      if (this.objInfo.classId == this.Constants.qualityProblemReportClassId) {
        this.visibleCreate = 'none'
      } else if (this.objInfo.classId == this.Constants.qualityCAPAClassId) {
        this.visibleCreate = ''
      } else {
        this.visibleCreate = 'none'
      }
    },
    printPage() {
      // window.print()
      let newstr = document.getElementById("aa").innerHTML;
      let oldstr = document.body.innerHTML;
      document.body.innerHTML = newstr;
      window.print();
      document.body.innerHTML = oldstr;

      this.$nextTick(() => {
        window.location.reload();
      })

    },
    routerReload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    pageRefresh() {
      this.logoInfo();
      this.routerReload()
    },

    cancelSaveAs() {
      this.saveAs = false;
    },

    closeCreateNew() {
      this.creatNew = false;
    },

    closeCreateChange() {
      this.creatChange = false;
    },

    addToChangeList(e) {
      this.creatNew = false;
      let relationshipMapVo = {};
      let arr = e.map(i => {
        return {
          ctrObjid: this.objInfo.id,
          ctrObjtype: this.objInfo.classId,
          effObjid: i.id,
          effObjtype: i.itemClass,
          name: i.itemNumber,
          relType: '4'
        };
      })
      relationshipMapVo.relationshipVoList = arr;
      axios.post('/pmdm/relationship/saveRelationship', relationshipMapVo)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            const obj = {
              id: e[0].itemId,
              classId: e[0].itemClass,
              subClassId: e[0].itemSubClassId,
              name: e[0].itemNumber
            }
            this.getLink(obj);
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      this.creatNew = false;
    },

    deleteQuality() {
      this.$confirm(
        this.$t("message.confirm.deleteObject"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let obj = {
            ...this.objInfo,
          };
          axios
            .get(`/pqm/quality/deleteQualityP1${this.params(obj)}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$emit("deletePage", this.tabInfo.name);
              } else {
                this.$message({
                  type: "info",
                  message: this.$t("message.error.delete"),
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },

    removeFavorite() {
      this.removeFavoriteInCommon({
        baseClassId: 401,
        number: this.tabInfo.name,
        ...this.objInfo,
      });
    },

    reload(e) {
      if (e == undefined) {
        this.logoInfo();
        return;
      }
      const obj = {
        id: e.itemId,
        classId: e.itemClassId,
        subClassId: e.itemSubClassId,
        title: e[0]
      };
      this.getLink(obj);
    },

    checkDelPriv(e) {
      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (e) {
        const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
        const privsArr = arr.map((i) => {
          return i.type;
        });
        if (privsArr.indexOf(25) != -1 || isSupAdmin) {
          this.deletePriv = true;
        }
      }
    },

    addFavorite() {
      let description_ = "";
      if (this.tabInfo.description) {
        description_ = ":" + this.tabInfo.description;
      }
      this.addFavoriteInCommon({
        baseClassId: 401,
        number: this.tabInfo.name + description_,
        ...this.objInfo,
      });
    },

    tabClick(res, index) {
      this.$store.commit("setTabID", { index, ...this.objInfo });
      const item = this.tabList[index]
      let obj = qualityTabList.find((i) => {
        return i.id == item.id;
      });
      let query = { ...this.objInfo };
      if (item.id == 4040105) {
        Object.assign(query, this.workflowInfo)
      };
      this.$router.push({
        path: obj.path,
        query
      });
      this.$store.commit('setTabIndex', { ...this.$store.state.objectId, index })

    },

    getTab() {
      this.$http
        .get("/pmdm/admin/getTab/" + this.objInfo.subClassId)
        .then((res) => {
          this.tabList = res.data.object.tabs.map(i => {
            i.path = qualityTabList.find(j => j.id == i.id).path
            return i;
          })
          const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
          this.tabClick(qualityTabList.find(j => j.id == this.tabList[tabIndex].id), tabIndex)

          this.tabIdLists = Array.from(this.tabList, ({ id }) => id);
          this.$getTabsIsUsedResult(this.tabIdLists).then(
            res => {
              this.tabList.map(item => {
                const isTrue = res.includes(item.id)
                this.$set(item, 'isResult', isTrue);
              });
            }
          );
        });
    },

    refreshTab() {
      this.$getTabsIsUsedResult(this.tabIdLists).then(
        res => {
          this.tabList.map(item => {
            const isTrue = res.includes(item.id)
            this.$set(item, 'isResult', isTrue);
          });
        }
      );
    },

    async logoInfo() {
      {
        var change_info = this.$store.state.change_info;
        console.log(change_info);
        var obj_get = {
          //获取change
          ...this.objInfo,
          ...change_info,
          tableId: 1,
        };
        var loadTableUrl = `/pqm/quality/loadTable${this.params(obj_get)}`;
        const res = await axios.get(loadTableUrl);
        const { columnInfo, rows } = res.data.object.table
        const columnList = columnInfo.ids;
        const cells = rows[0].cells;
        cells.map((i, e) => (i.columnId = columnList[e]));
        let arr = {
          name: 4010001,
          type: 4010002,
          description: 4010003,
          lifeCycle: 4010005,
          workflowId: 4010004
        };
        this.tabInfo = this.getPageInfo(arr, cells);
        this.workflowInfo = {
          ...this.tabInfo,
          currentStatusId: cells[columnList.indexOf(4010005)].id,
          workflowId: cells[columnList.indexOf(4010004)].id,
          data: Date.parse(new Date())
        };
        this.$store.commit("setTabInfo", this.tabInfo);
        //添加最近访问
        const obj = {
          baseClassId: 401,
          number: this.tabInfo.name,
          ...this.objInfo,
        };
        this.addRecentVistInCommon(obj);
        this.updateFavoriteInCommon(obj);
        this.getWorkflowByChangeId(rows[0].objId);
        this.getTab()
      }
    },

    getPageInfo(obj, cells) {
      let keys = Object.keys(obj);
      let newObj = {};
      Object.values(obj).map((i, e) => {
        let val = cells.find((j) => j.columnId == i)?.val || "";
        Object.assign(newObj, { [keys[e]]: val });
      });
      return newObj;
    },


    getWorkflowByChangeId(id) {
      var obj_get = {
        qualityId: id
      };
      var loadTableUrl = `/pqm/quality/getWorkflowByQualityId${this.params(obj_get)}`;
      this.$http.get(loadTableUrl).then((res) => {
        if (res.data.object.workflowStatus.statusType) {//提交变更工作流状态
          this.$store.commit("setChangeWorkflowStatus", res.data.object.workflowStatus.statusType);
        } else {
          this.$store.commit("setChangeWorkflowStatus", -1);
        };
        if ([3, 4].includes(res.data.object.workflowStatus.statusType)) {
          this.noChange = true;
        };
      })
        .catch(function (error) {
          console.log(error);
        });
    },
  },

  computed: {
    num() {
      return this.tabList.findIndex(i => i.path == this.$route.path)
    }
  },

  created() {
    const { id, classId, subClassId } = this.$route.query;
    const obj = { id, classId, subClassId };
    this.objInfo = obj;
    this.$store.commit("setObjectId", obj);
    this.logoInfo();
    this.getBaseClass();

  },
};
</script>

<style></style>

<style scoped>
.tabInfo-des {
  margin-left: 5px;
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.route-content {
  padding: 10px 15px;
  height: calc(100vh - 360px);
  overflow-y: scroll;
}

.content-title {
  display: flex;
  gap: 20px;
  padding-left: 20px;
  margin-top: 8px;

  .content-item {
    padding: 8px 15px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }

    &.active {
      border-bottom: 3px solid #4b92ff;
      color: #4b92ff;
    }
  }


}
</style>